export default "//yastatic.net/s3/distribution/pythia/frontend/_/104211be20de35fdef4675cb1ba6d532.png";